const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** Alinhado ao backend (RegisterSerializer min_length=8). */
const MIN_PASSWORD_LENGTH = 8;
const MIN_NAME_LENGTH = 3;
const MAX_NAME_LENGTH = 100;

export const validators = {
  email: (email: string): boolean => {
    if (!email || typeof email !== "string") return false;
    const trimmedEmail = email.trim();
    return trimmedEmail.length > 0 && EMAIL_REGEX.test(trimmedEmail);
  },

  password: (password: string): boolean => {
    if (!password || typeof password !== "string") return false;
    return password.length >= MIN_PASSWORD_LENGTH;
  },

  name: (name: string): boolean => {
    if (!name || typeof name !== "string") return false;
    const trimmedName = name.trim();
    return trimmedName.length >= MIN_NAME_LENGTH && trimmedName.length <= MAX_NAME_LENGTH;
  },

  passwordsMatch: (password: string, confirmPassword: string): boolean => {
    if (!password || !confirmPassword) return false;
    return password === confirmPassword;
  },
};
